<script>
import CandelaControl from '@/components/controls/CandelaControl'

export default {
  extends: CandelaControl,
  name: 'candela-progress',
  props: {
    indeterminate: {type: Boolean, default: () => false},
    message: {type: String, default: () => null},
    progress: {type: Number, default: () => 0}
  }
}
</script>
<template>
  <div class='d-flex flex-column'>
    <div class='overline primary--text mb-2'>{{label}}</div>
    <v-progress-linear :buffer-value='100'
      :value='indeterminate ? 100 : progress * 100'
      :indeterminate='indeterminate'/>
    <div v-if='message' class='align-self-end overline'>
      {{message}}
    </div>
  </div>
</template>
